import { StarShootingOutlineIcon } from './StarShootingOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 27A6F1B6-E095-494B-8CC7-660695DC6E70
 * name star-shooting-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-shooting-outline.svg
 * tags
 */
export const FavoriteShootingOutlineIcon = StarShootingOutlineIcon;
export default FavoriteShootingOutlineIcon